import Vue from 'vue'
import * as formatters from './formatters'
import Rules from '../plugins/validation'
import { mask } from 'vue-the-mask'

import Autocomplete from '../components/Autocomplete'
import DataTable from '../components/DataTable'
import DateBirthdayField from '../components/DateBirthdayField'
import MTextField from '../components/MTextField'
import MForm from '../components/MForm'
import DateField from '../components/DateField'
import DateRange from '../components/DateRange'
import DateTimeRange from '../components/DateTimeRange'
import Dialog from '../components/Dialog'
import ListDialog from '../components/ListDialog'
import ChipsEditaveis from '../components/ChipsEditaveis'
import Loading from '../components/Loading'
import MoneyTextField from '../components/MoneyTextField'
import SlideButton from '../components/SlideButton'
import Spin from '../components/Spin'
import MRadio from '../components/MRadio'
import DynamicSelect from '../components/DynamicSelect'
import Alert from '../components/Alert.vue'
import filters from '@/plugins/filters'
import HintMessage from '../components/HintMessage'
import ToolTip from '../components/ToolTip.vue'

const components = {
  Autocomplete,
  ChipsEditaveis,
  DataTable,
  DateBirthdayField,
  DateField,
  DateRange,
  Dialog,
  ListDialog,
  Loading,
  MoneyTextField,
  SlideButton,
  Spin,
  MTextField,
  MForm,
  MRadio,
  DynamicSelect,
  Alert,
  DateTimeRange,
  HintMessage,
  ToolTip
}

Vue.mixin({
  components,
  filters: { ...formatters },
  directives: { mask },
  computed: {
    ws () { return this.$http.defaults.baseURL },
    $rules: () => Rules,
    $filters: () => filters
  }
})
